import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { BaseEntityService } from './baseentity-service';
import { BehaviorSubject } from '../../../node_modules/rxjs';
import { CommonService } from './common-service';
import { PosicionService } from './posicion-service';
import * as moment from 'moment';

@Injectable()
export class EntregaService extends BaseEntityService {
    PosicionOptions: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    ForwardNegocioID: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    private posOptions = [];
    private entOptions = [];

    constructor(httpClient: HttpClient, private commonService: CommonService, private posicionService: PosicionService) {
        super(httpClient);
        this.Options.subscribe(newValue => {
            this.entOptions = newValue;
            let forward = newValue.find(x => x.EsPosicion);
            if (forward)
                this.ForwardNegocioID.next(forward.ID);
            this.getPosicionOptions();
        });
        this.posicionService.Options.subscribe(newValue => {
            this.posOptions = newValue;
            this.getPosicionOptions();
        });
    }

    getPosicionOptions() {

        // Se filtran los pagos diferidos con fechas anteriores a la actual.
        var sources = this.posOptions.filter(x => {
            const esPagoDiferido = x.Ent_Id === 4;
            if (esPagoDiferido && moment(x.Posicion, "DD/MM/YYYY").endOf("day").isSameOrAfter(moment(new Date()).endOf("day"))) {
                return x;
            } else if (!esPagoDiferido) {
                return x;
            }
        })

        const monthsMap = this.commonService.getMonthLabelsMapping();

        let tmpValue = sources.map(p => {

            const esPagoDiferido = p.Ent_Id === 4;
            const tmp = p.Posicion.split('-');

            return {
                Tipo: 'Posicion',
                Posicion: esPagoDiferido ? p.Posicion : monthsMap[tmp[0]] + '-' + tmp[1],
                Original: p.Posicion,
                ID_POS: p.ID,
                EsPosicion: true,
                EsPagoDiferido: esPagoDiferido,
                Time: p.Time,
                Entrega_Id: p.Ent_Id
            };
        }).reverse();
        tmpValue = tmpValue.sort((a, b) => {
          if (!a.EsPagoDiferido && !b.EsPagoDiferido) {
            return 0;
          } else if (a.EsPagoDiferido || b.EsPagoDiferido) {
            return Number(a.EsPagoDiferido) - Number(b.EsPagoDiferido);
          } else if (a.EsPagoDiferido && b.EsPagoDiferido) {
            return b.Time - a.Time;
          }
        });
        const tmpEntrega = this.entOptions.map(x => {
            x.Tipo = 'Entrega';
            return x;
        });
        const tmpArray = tmpEntrega.filter(x => !x.EsPosicion).concat(tmpValue);
        this.PosicionOptions.next(tmpArray);
    }

    responseItemToEntity(responseItem: any): any {
        return {
            ID: responseItem.Id,
            Entrega: responseItem.Entrega,
            EsPosicion: responseItem.EsPosicion
        };
    }

    apiRoute: string = '/api/entrega';
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/entrega-service.ts